/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $CompanyInspectionPeriodUpdate = {
    properties: {
        insectionPeriod: {
    type: 'Enum',
    isRequired: true,
},
    },
};